import {bookingApi} from "../../API/API";
import {SET_BOOKING_LIST, SET_NAV_PARAMS, SET_STATUS_LIST, UPDATE_BOOKINGS} from "./constans";
import {updateSavingStatus} from "../../globalState/app/actions";

export const setBookingList = (payload) => {
    return {
        type: SET_BOOKING_LIST,
        payload
    }
}

export const setNavParams = (payload) => {
    return {
        type: SET_NAV_PARAMS,
        payload
    }
}


export const setStatusList = (payload) => {
    return {
        type: SET_STATUS_LIST,
        payload
    }
}

export const updateBookings = (payload) => {
    return {
        type: UPDATE_BOOKINGS,
        payload
    }
}




export const setBookingListFromCache = (bookings) => async (dispatch) => {
    await dispatch(setBookingList(bookings))
}

export const setNavParamsFromCache = (navParams) => async (dispatch) => {
    await dispatch(setNavParams(navParams))
}



export const getBookingList = (params) => async (dispatch) => {
    let response = await bookingApi.getList(params);

    if (response.status) {
        return dispatch(setBookingList(response.data))
    }
}


export const getStatusList = (params) => async (dispatch) => {
    let response = await bookingApi.getStatusList(params);

    if (response.status) {
        dispatch(setStatusList(response.data))
    }
}

export const getNavParams = (params) => async (dispatch) => {
    let response = await bookingApi.getNavParams(params);

    if (response.status) {
        dispatch(setNavParams(response.data))
    }
}


export const setBookingStatus = (data) => async (dispatch) => {
    dispatch(updateSavingStatus({status: "loading"}))
    let response = await bookingApi.setStatus(data);

    if (response.status) {
        dispatch(updateSavingStatus({status: "success"}))
        dispatch(updateBookings({[data.orderId]: response.data}))
        return true
    } else {
        dispatch(updateSavingStatus({status: "error", message: response.data.message}))
    }

}

